import type { ReactNode } from 'react';

export const symbol_lists: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M399-160q-36 0-61-25.58t-25-61.5Q313-283 338-308t61-25h395q36 0 61 25t25 60.92q0 35.92-25 61.5T794-160H399Zm1-233q-35.89 0-61.44-25.58Q313-444.16 313-480.08t25.56-61.42Q364.11-567 400-567h393q35.89 0 61.44 25.58Q880-515.84 880-479.92t-25.56 61.42Q828.89-393 793-393H400Zm-1-234q-36 0-61-25.58t-25-61.5Q313-750 338-775t61-25h395q36 0 61 25t25 60.92q0 35.92-25 61.5T794-627H399Zm-293.42-25.58Q80-678.16 80-714.08T105.58-775q25.58-25 61.5-25T228-775q25 25 25 60.92t-25 61.5Q203-627 167.08-627t-61.5-25.58ZM166.92-393q-35.92 0-61.42-25.58T80-480.08q0-35.92 25.58-61.42t61.5-25.5q35.92 0 61.42 25.58t25.5 61.5q0 35.92-25.58 61.42t-61.5 25.5Zm.16 233q-35.92 0-61.5-25.58T80-247.08Q80-283 105.58-308t61.5-25Q203-333 228-308t25 60.92q0 35.92-25 61.5T167.08-160Z"
		/>
	</svg>
);
